import { toast } from "react-toastify";
import { ReactComponent as ToastSuccesImg } from "../imgForComponents/toastSuccesImg.svg";

const succesHandler = () => {
  toast.success("Зміни внесено успішно!", { icon: <ToastSuccesImg /> });
};

export default succesHandler;
